<template>
<v-card class="mx-2 pa-4 card-personalizada slide-card flex-grow-1"
    style="min-width: 0; max-width: 100%;">
    <v-card-title>
        {{ $t('mensajes.datos_pasajeros.datos_peregrino', { index: numero }) }}
    </v-card-title>
    <v-card-text>
        <div>


            <v-row dense class="mt-6 mb-2">
                <v-text-field v-model="pasajero.nombre" :disabled="disabled" :rules="reglas('nombre')" :error-messages="errores.nombre" class="mb-2"
                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'nombre') }"
                    :label="$t('mensajes.datos_pasajeros.nombre')" type="text" outlined
                    dense autocomplete="off" hide-details="auto">
                </v-text-field>
            </v-row>

            <v-row dense class="mb-2">
                <v-col cols="6">
                    <v-text-field v-model="pasajero.primer_apellido" :disabled="disabled" :rules="reglas('primer_apellido')" :error-messages="errores.primer_apellido" class="mb-2"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'primer_apellido') }"
                        :label="$t('mensajes.datos_pasajeros.primer_apellido')" type="text"
                        outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field v-model="pasajero.segundo_apellido" :disabled="disabled" :rules="reglas('segundo_apellido')" :error-messages="errores.segundo_apellido" class="mb-2"
                        :label="$t('mensajes.datos_pasajeros.segundo_apellido')" type="text"
                        outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                <v-col cols="6">
                    <v-select v-model="pasajero.sexo" :disabled="disabled" :rules="reglas('sexo')" :error-messages="errores.sexo" :items="sexos" item-text="name"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'sexo') }"
                        :label="$t('mensajes.datos_pasajeros.sexo')"
                        item-value="value" outlined dense hide-details="auto" class="mb-2">
                    </v-select>
                </v-col>
                <v-col cols="6">
                    <v-text-field v-model="pasajero.fecha_nacimiento" :disabled="disabled" :rules="reglas('fecha_nacimiento')" :error-messages="errores.fecha_nacimiento" class="mb-2"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'fecha_nacimiento') }"
                        :label="$t('mensajes.datos_pasajeros.fecha_nacimiento')" outlined
                        dense hide-details="auto" placeholder="dd/mm/yyyy"
                         @input="formatearFecha"
                        maxlength="10">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row dense class="mb-2">
                <v-col v-if="!mostrarFormularioReducido" cols="4" class="pr-0">
                    <v-select v-model="pasajero.tipo_documento" :disabled="disabled" :rules="reglas('tipo_documento')" :error-messages="errores.tipo_documento" :items="tipoDeDocumentos"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'tipo_documento') }"
                        :label="$t('mensajes.datos_pasajeros.tipo_documento')"
                        item-text="name" item-value="value" outlined dense hide-details="auto"
                        class="mr-1">
                    </v-select>
                </v-col>
                <v-col :cols="mostrarFormularioReducido ? 12 : (isSpanish && isNacionalidadEspania(pasajero) ? 5 : 8)" :class="mostrarFormularioReducido ? '' : 'pl-0'">
                    <v-text-field v-model="pasajero.numero_documento" :disabled="disabled" :rules="reglas('numero_documento')" :error-messages="errores.numero_documento"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'numero_documento') }"
                        :label="$t('mensajes.datos_pasajeros.numero_documento')"
                        :error="!isValidDocument(pasajero.tipo_documento, pasajero.numero_documento)"
                        type="text" outlined dense autocomplete="off" hide-details="auto"
                        @input="pasajero.numero_documento = String($event || '').toUpperCase()">
                    </v-text-field>
                </v-col>
                <v-col v-if="!mostrarFormularioReducido && isSpanish && isNacionalidadEspania(pasajero)" cols="3" class="pl-0">
                    <v-text-field v-model="pasajero.soporte_documento" :disabled="disabled" :rules="reglas('soporte_documento')" :error-messages="errores.soporte_documento"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'soporte_documento') }"
                        :label="$t('mensajes.datos_pasajeros.soporte_documento')"
                        type="text" outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row dense class="mb-2">
                <v-col v-if="!mostrarFormularioReducido" cols="6">
                    <v-text-field v-model="pasajero.telefono_fijo" :disabled="disabled" :rules="reglas('telefono_fijo')" :error-messages="errores.telefono_fijo"
                        :label="$t('mensajes.datos_pasajeros.telefono_fijo')" type="text"
                        outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
                <v-col :cols="mostrarFormularioReducido ? 12 : 6">
                    <v-text-field v-model="pasajero.telefono_movil" :disabled="disabled" :rules="reglas('telefono_movil')" :error-messages="errores.telefono_movil"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'telefono_movil') }"
                        :label="$t('mensajes.datos_pasajeros.telefono_movil')" type="text"
                        outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                <v-text-field v-model="pasajero.email" :disabled="disabled" :rules="reglas('email')" :error-messages="errores.email"
                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'email') }"
                    :label="$t('mensajes.datos_pasajeros.email')" type="text" outlined dense
                    :error="pasajero.email && !_emailValido(pasajero.email)"
                    autocomplete="off" hide-details="auto">
                </v-text-field>
            </v-row>

            <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                <v-text-field v-model="pasajero.direccion" :disabled="disabled" :rules="reglas('direccion')" :error-messages="errores.direccion"
                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'direccion') }"
                    :label="$t('mensajes.datos_pasajeros.direccion')" type="text" outlined
                    dense autocomplete="off" hide-details="auto">
                </v-text-field>
            </v-row>

            <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                <v-col cols="6">
                    <v-text-field v-model="pasajero.poblacion" :disabled="disabled" :rules="reglas('poblacion')" :error-messages="errores.poblacion"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'poblacion') }"
                        :label="$t('mensajes.datos_pasajeros.poblacion')" type="text"
                        outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-select v-if="isNacionalidadEspania(pasajero)"
                        v-model="pasajero.provincia" :disabled="disabled" :rules="reglas('provincia')" :error-messages="errores.provincia" :items="provinciasEspana"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'provincia') }"
                        :label="$t('mensajes.datos_pasajeros.provincia')" outlined dense
                        hide-details="auto">
                    </v-select>
                    <v-text-field v-else v-model="pasajero.provincia" :disabled="disabled" :rules="reglas('provincia')" :error-messages="errores.provincia"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'provincia') }"
                        :label="$t('mensajes.datos_pasajeros.provincia')" type="text"
                        outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row v-if="!mostrarFormularioReducido" dense class="mb-2">
                <v-col cols="6">
                    <v-text-field v-model="pasajero.codigo_postal" :disabled="disabled" :rules="reglas('codigo_postal')" :error-messages="errores.codigo_postal"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'codigo_postal') }"
                        :label="$t('mensajes.datos_pasajeros.codigo_postal')" type="text"
                        outlined dense autocomplete="off" hide-details="auto">
                    </v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-select v-model="pasajero.nacionalidad" :disabled="disabled" :rules="reglas('nacionalidad')" :error-messages="errores.nacionalidad" :items="codigosPais"
                        item-text="name" item-value="name"
                        :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'nacionalidad') }"
                        :label="$t('mensajes.datos_pasajeros.nacionalidad')" outlined dense
                        hide-details="auto">
                    </v-select>
                </v-col>
            </v-row>

            <v-row v-if="!mostrarFormularioReducido && isSpanish && isNacionalidadEspania(pasajero)" dense class="mb-2">
                <v-text-field v-model="pasajero.parentesco" :disabled="disabled" :rules="reglas('parentesco')" :error-messages="errores.parentesco"
                    :class="{ 'required-field': isRequiredFieldMissing(pasajero, 'parentesco') }"
                    :label="$t('mensajes.datos_pasajeros.parentesco')" type="text" outlined
                    dense autocomplete="off" hide-details="auto">
                </v-text-field>
            </v-row>


        </div>
    </v-card-text>
</v-card>
</template>
<script>
export default {
  props: {
    pasajero: { type: Object, required: true }, numero: { type: Number, default: 1 },
    mostrarFormularioReducido: Boolean, isSpanish: Boolean, disabled: Boolean,
    codigosPais: { type: Array, default: () => [] }, provinciasEspana: { type: Array, default: () => [] },
    errores: { type: Object, default: () => ({}) }, reglas: { type: Function, default: () => [] },
    isRequiredFieldMissing: { type: Function, default: () => false },
  },
  computed: {
    sexos() { return [{ name: this.$t('mensajes.datos_pasajeros.sexo_opciones.hombre'), value: 'H' }, { name: this.$t('mensajes.datos_pasajeros.sexo_opciones.mujer'), value: 'M' }]; },
    tipoDeDocumentos() { return ['DNI', 'NIE', 'PASAPORTE'].map(value => ({ name: this.$t('mensajes.datos_pasajeros.tipo_documento_opciones.' + value.toLowerCase()), value })); },
  },
  methods: {
    isNacionalidadEspania(pasajero) { return ['españa', 'espana', 'es'].includes(String(pasajero.nacionalidad || '').trim().toLowerCase()); },
    isValidDocument(tipo, valor) { return !!String(valor || '').trim(); },
    _emailValido(valor) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(valor); },
    formatearFecha(valor) {
      const digitos = String(valor || '').replace(/[^0-9]/g, '').slice(0, 8);
      this.pasajero.fecha_nacimiento = [digitos.slice(0, 2), digitos.slice(2, 4), digitos.slice(4)].filter(Boolean).join('/');
    },
  },
};
</script>
<style scoped>
.card-personalizada { border: 4px solid #FF9C00 !important; border-radius: 15px !important; }
.required-field ::v-deep .v-label { color: #d32f2f !important; }
.required-field ::v-deep .v-label::after { content: ' *'; color: #d32f2f; }
.slide-card { animation: slideIn .5s ease-out; }
@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
</style>
